export const USER_PROFILE_STATUS_INVITED = 'invited';
export const USER_PROFILE_STATUS_JOINED = 'joined';
